import { render, staticRenderFns } from "./ProfilesSimpleProductTable.vue?vue&type=template&id=ccb86872&scoped=true"
import script from "./ProfilesSimpleProductTable.vue?vue&type=script&lang=js"
export * from "./ProfilesSimpleProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb86872",
  null
  
)

export default component.exports